import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';


// Format : "court" "simple" "chip" "deletablechip"

class Utilisateur extends React.Component {

    //componentDidMount() {

    //    console.log("Utilisateur component did mount", this.props.utilisateur);

    //}

    render() {

        const { utilisateur, format, erreur, ...other } = this.props;


        /* TODO ajouter l'icone si disponible, sinon on se contente de l'avatar avec les majuscules */

        var str = utilisateur.codePO ? utilisateur.codePO : '';

        var prenomNom = utilisateur.prenom ? utilisateur.prenom : '';
        prenomNom += utilisateur.nom ? ' ' + utilisateur.nom : '';

        if (erreur) {
            prenomNom = erreur;
        }

        if (format === "court") {
            return <Tooltip title={prenomNom}><p>{str}</p></Tooltip>;
        }

        if (format === "simple") {
            return prenomNom;
        }
        
        if (format === "chip") {
            return (
                <Chip
                    {...other}
                    avatar={<Avatar>{utilisateur.codePO}</Avatar>}
                    label={prenomNom}
                />
            );
        }
        
        if (format === "deletablechip") {
            return (
                <Chip
                    {...other}
                    avatar={<Avatar>{utilisateur.codePO}</Avatar>}
                    label={prenomNom}
                    onDelete={this.props.onDelete}
                />
            );
        }



        str = utilisateur.codePO ? ' - ' + prenomNom : prenomNom;
        return str;
    }
}

Utilisateur.propTypes = {
    format: PropTypes.string,
    erreur: PropTypes.string,
    utilisateur: PropTypes.object.isRequired,
    onDelete: PropTypes.func
};


Utilisateur.defaultProps = {
    format: "court",
    erreur: ""
};

export default Utilisateur;